import type {LanguageSelectorTranslation} from '../languageSelectorTranslationType';

export const translation: LanguageSelectorTranslation = {
  nav: {
    homeAriaLabel: (ctx) => `Início do ${ctx.brand}`,
    languageButtonLabel: `Idioma`,
    languageModalTitle: `Escolher idioma`,
    languageModalCloseLabel: `Fechar menu de idiomas`,
  },
  languageOptions: {
    'en-US': {
      label: `Inglês`,
      countryCodes: [`US`],
    },
    'en-KE': {
      label: `Inglês (Quênia)`,
      countryCodes: [`KE`],
    },
    'en-NG': {
      label: `Inglês (Nigéria)`,
      countryCodes: [`NG`],
    },
    'en-SG': {
      label: `Inglês (Singapura)`,
      countryCodes: [`SG`],
    },
    'pt-PT': {
      label: `Português`,
      countryCodes: [`PT`],
    },
    'pt-BR': {
      label: `Português (Brasil)`,
      countryCodes: [`BR`],
    },
    'de-DE': {
      label: `Alemão`,
      countryCodes: [`DE`],
    },
    'de-AT': {
      label: `Deutsch (Österreich)`,
      countryCodes: [`AT`],
    },
    'de-CH': {
      label: `Deutsch (Schweiz)`,
      countryCodes: [`CH`],
    },
    'es-ES': {
      label: `Espanhol`,
      countryCodes: [`ES`],
    },
    'fr-FR': {
      label: `Francês`,
      countryCodes: [`FR`],
    },
    'it-IT': {
      label: `Italiano`,
      countryCodes: [`IT`],
    },
    'nl-NL': {
      label: `Holandês`,
      countryCodes: [`NL`],
    },
    'pl-PL': {
      label: `Polski`,
      countryCodes: [`PL`],
    },
    'sv-SE': {
      label: `Nórdico & Báltico`,
      countryCodes: [`SE`],
    },
    'da-DK': {
      label: `Dansk`,
      countryCodes: [`DK`],
    },
    'fi-FI': {
      label: `Suomi`,
      countryCodes: [`FI`],
    },
    'no-NO': {
      label: `Norsk`,
      countryCodes: [`NO`],
    },
    'is-IS': {
      label: `Íslenska`,
      countryCodes: [`IS`],
    },
    'ja-JP': {
      label: `Japonês`,
      countryCodes: [`JP`],
    },
    'ko-KR': {
      label: `Coreano`,
      countryCodes: [`KR`],
    },
    'zh-Hans-CN': {
      label: `Mandarim`,
      countryCodes: [`CN`],
    },
    'yue-Hant-HK': {
      label: `Cantonês`,
      countryCodes: [`HK`],
    },
    'vi-VN': {
      label: `Tiếng Việt`,
      countryCodes: [`VN`],
    },
    'th-TH': {
      label: `Tailandês`,
      countryCodes: [`TH`],
    },
    'id-ID': {
      label: `Bahasa Indonesia`,
      countryCodes: [`ID`],
    },
    'sw-KE': {
      label: `Kiswahili`,
      countryCodes: [`KE`],
    },
    'hi-IN': {
      label: `Hindi`,
      countryCodes: [`IN`],
    },
    'bn-BD': {
      label: `বাংলা`,
      countryCodes: [`BD`],
    },
    'mr-IN': {
      label: `मराठी`,
      countryCodes: [`IN`],
    },
    'te-IN': {
      label: `తెలుగు`,
      countryCodes: [`IN`],
    },
    'fa-IR': {
      label: `Persa`,
      countryCodes: [`IR`],
    },
    'ur-PK': {
      label: `اردو`,
      countryCodes: [`PK`],
    },
    'pa-PK': {
      label: `پنجابی`,
      countryCodes: [`PK`],
    },
    'pcm-NG': {
      label: `Naijá Pidgin`,
      countryCodes: [`NG`],
    },
    'ru-RU': {
      label: `Russo`,
      countryCodes: [`RU`],
    },
    'ar-SA': {
      label: `Árabe`,
      countryCodes: [`SA`],
    },
    'ar-AE': {
      label: `العربية (الإمارات)`,
      countryCodes: [`AE`],
    },
    'ar-QA': {
      label: `العربية (قطر)`,
      countryCodes: [`QA`],
    },
    'ar-MA': {
      label: `Árabe marroquino`,
      countryCodes: [`MA`],
    },
    'tr-TR': {
      label: `Türkçe`,
      countryCodes: [`TR`],
    },
  },
  languageModal: {
    title: `Escolher idioma`,
    closeLabel: `Fechar menu de idiomas`,
  },
  languageHint: (ctx) => `Salta entre ${ctx.localesCount}+ idiomas num clique.`,
  readPagePrompt: ({languageLabel}) => `Lê esta página em ${languageLabel}.`,
};
